import React, { useState, useEffect }  from 'react'
import { convertDateToUTC } from "../util/DateUtils"
import {config} from '../config'
import SearchUserRanking from './SearchUserRanking'
import TournamentDropdown from './TournamentDropdown'
import Modal from 'react-bootstrap/Modal'
import * as txApi from '../clients/tx-sls-client'

//Naveen-If linodeoption is 1 image load from linode and 0 image load from server.
const linodeurl = config()['linode-url']
const txdomain = config()['tourneyx-url']
const TourneyDetails = ({ tournamentDetails }) => {      
const [linodeoption,setLinodeoption] = useState('');
useEffect(() =>{
    txApi.getImageSourceOption('load_images_from_linode').then((response)=>{
        setLinodeoption(response);
      })
},[]);
  
  console.log('React- TourneyDetails.js linodeoption',linodeoption);
  const formatDate = (date, timezone) => {
    const convertedDate = convertDateToUTC(date, timezone)
    
    return convertedDate.toLocaleString('en-US', {
      month: 'long',
      day: '2-digit', 
      hour: '2-digit',
      minute: '2-digit',
    }) 
  }

  const formatYear = (date) => {
    return new Date(date).toLocaleString('en-US', {
      year: 'numeric'
    }) 
  }

  return (
    <>
      {
        
      /*
      <div className="tourney-banner">
        <img id='#tourneylogo' src={`${txdomain}/app/lib/logos/${tournamentDetails.logo}`}
        onError={(event) => {event.target.src = '/leaderboard/default-tourney-logo.jpg'}}/>
      </div>
        */
       // code 
        /*onError={(event) => {event.target.src = '/leaderboard/default-tourney-logo.jpg'}}*/
      }

      { (linodeoption == 1) ?
      //linode
      <div className="tourney-banner">
        <img id='#tourneylogo' src={`${linodeurl}/logos/${tournamentDetails.logo}`}
        onError={(event) => {event.target.src = `${linodeurl}/leaderboard_images/default-tourney-logo.jpg`}}/> 
        </div> :
      //server
      <div className="tourney-banner">
        <img id='#tourneylogo' src={`${txdomain}/app/lib/logos/${tournamentDetails.logo}`}
        onError={(event) => {event.target.src = '/leaderboard/default-tourney-logo.jpg'}}/> 
        </div> 
      }
      
     

      {
        parseInt(tournamentDetails.is_nationwide) 
        ? <div className="tourney-location">Nationwide</div>
        : <div className="tourney-location">{tournamentDetails.city}, {tournamentDetails.state}{ tournamentDetails.country_name ? ',' : ''} { tournamentDetails.country_name ? tournamentDetails.country_name : '' }</div>
      }
      {
      
      // New datetime values will show values directly from response
      // Change added on 03-11-2021

      <div className="tourney-meta">
        {tournamentDetails.react_time_format}, {tournamentDetails.timezone} • {tournamentDetails.tourney_type_name} 
      </div>


      }

      <div className="show-mobile">
          
          <TournamentDropdown otherTournamentsList={tournamentDetails.other_tournaments_list ? tournamentDetails.other_tournaments_list : null} tournamentInfo = {tournamentDetails} />

          <br/>
      </div>

      { 
        
        (tournamentDetails && tournamentDetails.show_standings === '1'  && ( tournamentDetails.tourney_type != 4 && tournamentDetails.tourney_type != 16)) ?
        
        <SearchUserRanking registeredAnglers={tournamentDetails?.registered_anglers ? tournamentDetails.registered_anglers : null} tournamentInfo = {tournamentDetails} />
        
        :
      
        null
        
      }
      
      <br/>
            
      <hr/>


      <div id='tournament-description' class="tournament-description-a" dangerouslySetInnerHTML={{ __html: tournamentDetails.description }} />
    </>
  )

  
}

export default TourneyDetails